import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/_services/api-Services/api-request.service';
import { LoadingService } from '@app/_services/LoadingService/loading.service';
import { HasClaimDirective } from '@app/directives/has-claim.directive';
import { PageDto } from '@app/shared/model/page.model';
import { RoleDto } from '@app/shared/model/role.model';
import { CLAIMS } from '@app/shared/utilities/constants';
import { encrypt } from '@app/utilities/enc-dec.util';
import { ModalDismissReasons, NgbAccordionModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DataTablesModule } from 'angular-datatables';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-role',
  standalone: true,
  imports: [DataTablesModule,CommonModule,NgbModule,NgbAccordionModule,ReactiveFormsModule,TranslateModule,HasClaimDirective],
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss'
})
export class RoleComponent implements OnInit, AfterViewInit, OnDestroy{
  public items = ['First', 'Second', 'Third'];
  closeResult: string;
  public readonly CLAIMS = CLAIMS;
  roles:RoleDto[]=[]
  pages!:PageDto[]
  isActive: boolean = false;
  roleForm!: FormGroup;
  selectedRole:RoleDto | null=null;
  showModal=false;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  constructor(
    private fb: FormBuilder,
    private toastService: ToastrService,
    private apiRequestService: ApiRequestService,
    private router: Router,
    private loaderService: LoadingService,
    private modalService: NgbModal,
    private cdRef : ChangeDetectorRef

  ) {}
  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      lengthMenu: [5, 10, 25],
      // destroy: true
    };
    this.getRoles()
   }
   ngAfterViewInit(): void {
    this.dtTrigger.next(null); // Initialize DataTable when the component view is fully initialized
  }
   getRoles(): void {
    this.apiRequestService.getRequest<RoleDto[]>(`Role/${this.isActive}`)
      .subscribe((response: HttpResponse<RoleDto[]>) => {
        if (response.body) {
          this.roles = response.body;
          this.reinitializeDataTable();
        }
      }, error => {
        this.toastService.error('Failed to load roles!', 'Error');
      });
  }
  private reinitializeDataTable(): void {
    // Destroy existing DataTable instance if it exists
    if ($.fn.dataTable.isDataTable('#table1')) {
      $('#table1').DataTable().clear().destroy();
    }

    this.cdRef.detectChanges(); // Ensure the view is updated before reinitializing
    this.dtTrigger.next(null); // Trigger reinitialization
  }
  redirectToRole(): void {
    this.router.navigate([`/add-role`]);
  }
  
  deleteRole(): void {
    
    this.apiRequestService.deleteRequest<RoleDto>(`Role/${this.selectedRole?.id}`)
      .subscribe((response: HttpResponse<RoleDto>) => {
        
        if (response.status >= 200 ) {
          this.toastService.success('Role deleted successfully!', 'Success');
          this.getRoles();
        } else {
          this.toastService.error('Some error occurred!', 'Error');
        }
      }, err => {
        const error = err.error || 'Some error occurred!';
        this.toastService.error(error, 'Error');
      });
      this.resetModal()

  }
  openForEdit(role: RoleDto): void {
    const encryptedId = encrypt(role.id.toString());
    this.router.navigate([`role/${encryptedId}`]);
  }
  confirmDelete(role: RoleDto)
  {
    this.showModal=true
    this.selectedRole=role
  }
  resetModal()
  {
    this.showModal=false;
    this.selectedRole=null
  }
  deleteModal(content: any, designation: RoleDto) {
    this.selectedRole = designation; // Set the selected department to delete
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'md' })
      .result.then((result) => {
        if (result === 'Delete') {
          this.deleteRole(); // Call the delete function
        }
        // Close modal and set focus to delete button (optional)
        this.setFocusToDeleteButton();
      }, (reason) => {
        // Just close the modal without any action
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.setFocusToDeleteButton();
      });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  setFocusToDeleteButton() {
    // Ensure the element exists and focus on it
    const deleteButton = document.querySelector('.btn-outline-danger') as HTMLElement;
    if (deleteButton) {
      deleteButton.focus();
    }
  }

  ngOnDestroy(): void {
    
    // if ($.fn.dataTable.isDataTable('#table1')) {
    //   $('#table1').DataTable().destroy();
    // }
    // this.dtTrigger.unsubscribe();
    // if (this.dtTrigger) {
    //   this.dtTrigger.unsubscribe();
    // }
    if ($.fn.dataTable.isDataTable('#table1')) {
      $('#table1').DataTable().destroy();
    }
    this.dtTrigger.unsubscribe();
    window.removeEventListener('beforeunload', this.destroyDataTable);
  }
  private destroyDataTable = () => {
    if ($.fn.dataTable.isDataTable('#table1')) {
      $('#table1').DataTable().destroy();
    }
  };
}
